import { render, staticRenderFns } from "./ySortColumn.vue?vue&type=template&id=60448152&scoped=true"
import script from "./ySortColumn.vue?vue&type=script&lang=js"
export * from "./ySortColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60448152",
  null
  
)

export default component.exports